import updateGeoJsonURL from '../../utils/update-geoJson-URL';
import waHttp from './wa-http';
import waRequest from './wa-request';

export const apiBase = '/intel/v3';

/**
 * Initiate authenticated GET ${apiBase}/alerts/searches
 *
 * @param filter
 * @param locale
 * @param page
 * @param size
 * @param sort
 * @returns {Promise}
 */
function getAlerts(filter, locale = 'en', page = 0, size = 25, sort = ['publishedDate,desc']) {
  const url = `${apiBase}/alerts/searches`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'post',
    params: {
      locale,
      page,
      size,
      sort,
    },
    data: filter,
  });
}

function getAllAlerts(filter = {status: 'Active'}, locale = 'en', sort = ['publishedDate,desc']) {
  const url = `${apiBase}/alerts/searches`;

  return waRequest
    .requestAllPages({
      url: url,
      method: 'post',
      params: {
        locale,
        size: 1000,
        sort,
      },
      data: filter,
    })
    .then((pagedResults) => {
      return waRequest.extractAllPagesResult(pagedResults, 'data.content');
    });
}

/**
 * Initiate authenticated GET ${apiBase}/alerts/${alertId}
 *
 * @param alertId
 * @param locale
 * @param returnMapImage
 * @param signal
 * @returns {Promise}
 */
function getAlertById(alertId, locale = 'en', returnMapImage = false, signal) {
  const url = `${apiBase}/alerts/${alertId}`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'get',
    signal,
    params: {
      locale,
      returnMapImage,
    },
  });
}

function getAlertByIdConfigPattern({pathParams: {alertId, returnMapImage = false}, params: {locale} = {}, signal}) {
  return getAlertById(alertId, locale, returnMapImage, signal);
}

/**
 * Initiate authenticated GET ${apiBase}/alerts/${alertId}/versions
 *
 * @param pathParams
 * @param params
 * @param signal
 * @returns {Promise}
 */
function getAlertVersions({pathParams: {alertId}, params = {}, signal}) {
  const url = `${apiBase}/alerts/${alertId}/versions`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'get',
    params,
    signal,
  });
}

/**
 * Initiate authenticated GET ${apiBase}/alerts/${alertId}/versions/${versionId}
 *
 * @param pathParams
 * @param params
 * @param signal
 * @returns {Promise}
 */
function getAlertVersionById({pathParams: {alertId, versionId}, params = {}, signal}) {
  const url = `${apiBase}/alerts/${alertId}/versions/${versionId}`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'get',
    params,
    signal,
  });
}

/**
 * Initiate authenticated POST ${apiBase}/alerts/reports
 *
 * @param body
 * @param urlParams
 * @returns {Promise}
 */
function exportAlerts(body, urlParams) {
  const url = `${apiBase}/alerts/reports`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'post',
    data: body,
    params: urlParams,
    responseType: 'blob',
  });
}

function getAlertGeoJson(geoJsonUrl, signal) {
  return waHttp.httpRequest({
    baseURL: '',
    url: updateGeoJsonURL(geoJsonUrl),
    method: 'get',
    signal,
  });
}

function getKeywords({params: {locale, isDisabled}}) {
  const url = `${apiBase}/keywords`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'get',
    params: {
      locale,
      isDisabled,
      size: 500,
    },
  });
}

export default {
  getAlerts,
  getAlertById,
  exportAlerts,
  getAllAlerts,
  getAlertGeoJson,
  getAlertByIdConfigPattern,
  getAlertVersions,
  getAlertVersionById,
  getKeywords,
};
